module.exports = __webpack_public_path__ + "a8a10a3e/img/SOURCERY_poweredby_web.9819842b.png";